import {Component} from '@angular/core';
import {NavigationService} from "@shared/services/navigation-service.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "@shared/services/data.service";
import {ToastService} from "@shared/services/toast.service";
import { EcommerceService } from '../ecommerce.service';

@Component({
  selector: 'app-createproduct',
  templateUrl: './createproduct.component.html',
  styleUrls: ['./createproduct.component.scss']
})
export class CreateproductComponent {
  public isSubmitted = false;
  public editMode = false;
  public productId :any;
  images: { imageUrl: string; isDefault: boolean }[] = [];
  public newVariantTitle = '';
  public newVariantValue = '';
  public newVariantPriceModifier: number = 0;
  public product = {
    name: "",
    description: "",
    price: '',
    availableQuantity: "",
    productCategory: {
      id: ''
    },
    images: this.images,
    variants: [] as Variant[] // Add variants field
  }
  public categoriesList: any[] = [];
  constructor(public service: EcommerceService,
              public toast: ToastService,
              public navigation: NavigationService,
              public spinner: NgxSpinnerService,
              public router: Router,
              public dataService: DataService,
              public route: ActivatedRoute) {
  }

  ngOnInit(): void {

    this.service.getAllCategories().subscribe((res: any) => {
      var result = res.data;
      var categories = result.map((item: { id: any; name: any; }) => ({
        value: item.id,
        label: item.name,
      }));
      this.categoriesList = [...categories];
      this.product.productCategory.id = this.categoriesList.length > 0 ? this.categoriesList[0].value : null;
    }, error => {
      console.log(error);
      this.spinner.hide();
  
    });
    
    this.productId = this.route.snapshot.paramMap.get('id');
    if( this.productId != -1){
      this.editMode = true;

      this.service.getProduct(this.productId).subscribe((res: any) => {
        this.product = res;
        this.images = this.product.images;
      }, error => {
        console.log(error);
        this.spinner.hide();
    
      });
    }
  }

  public SaveProduct() {
    console.log(this.product);
    this.isSubmitted = true;
    if (!this.product.name.toString().trim() ||
     !this.product.description.toString().trim() ||
      !this.product.price.toString().trim() || 
      !this.product.availableQuantity.toString().trim() ||
       !this.product.productCategory?.id?.toString().trim() 
    ) {
      return;
    }
    this.product.images = this.images;
    this.spinner.show();
    if (this.editMode){
      this.service.editProduct(this.product, this.productId).subscribe((res: any) => {
      this.toast.success("Product Updated Successfully");
        this.router.navigate(['/ecommerce/products']);
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
    }
    else{
     
      this.service.createProduct(this.product).subscribe((res: any) => {
      this.toast.success("Product Created Successfully");
        this.router.navigate(['/ecommerce/products']);
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
    }
  
  }

  changeFilter(value: any) {
     this.product.productCategory.id = value;
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  onImageUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      Array.from(input.files).forEach((file) => {

        this.uploadImage(file).then((res: any) => {
          this.spinner.hide();
          this.images.push({ imageUrl: res.fileUrl, isDefault: false });
        }, error => {
          console.log(error)
          let errorMessage = error && error.error ? error.error.error : error.name;
          this.toast.error(errorMessage ?? 'Error uploading image')
          this.spinner.hide();
        }
        )
      })
    }
  }

  uploadImage(file: any) {
    return this.dataService.uploadImage(file);
  }

  removeImage(index: number): void {
    this.images.splice(index, 1);
  }

  setAsDefault(index: number): void {
    this.images.forEach((img, i) => (img.isDefault = i === index));
  }

   // Add a new variant
   addVariant() {
    if (this.newVariantTitle.trim()) {
      this.product.variants.push({ title: this.newVariantTitle, values: [], selectedValueIndex: undefined });
      this.newVariantTitle = '';
    }
  }

  // Remove a variant
  removeVariant(index: number) {
    this.product.variants.splice(index, 1);
  }

  // Add a value to a specific variant
  addVariantValue(variantIndex: number) {
    if (this.newVariantValue.trim()) {
      this.product.variants[variantIndex].values.push({
        value: this.newVariantValue,
        selected: false,
        priceModifier: this.newVariantPriceModifier || 0
      });
      this.newVariantValue = '';
      this.newVariantPriceModifier = 0;
    }
  }

  // Remove a value from a specific variant
  removeVariantValue(variantIndex: number, valueIndex: number) {
    this.product.variants[variantIndex].values.splice(valueIndex, 1);
  }

  // Toggle the selected state of a variant value
  toggleVariantValue(variantIndex: number, valueIndex: number) {
    this.product.variants[variantIndex].values[valueIndex].selected = 
      !this.product.variants[variantIndex].values[valueIndex].selected;
  }

}

export interface VariantValue {
  value: string;
  selected: boolean;
  priceModifier?: number;
}

export interface Variant {
  title: string;
  values: VariantValue[];
  selectedValueIndex?: number;
}